// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero-module--root--3Z-zL","logo":"Hero-module--logo--3u-ge","backLink":"Hero-module--backLink--EP0f3","backLink__icon":"Hero-module--backLink__icon--3713q"};